module.exports = __webpack_public_path__ + "img/mr-singhs-pizza.70838783.png";